function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("polyline", {
  points: "17 1 21 5 17 9"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3 11V9a4 4 0 0 1 4-4h14"
});

var _ref3 =
/*#__PURE__*/
React.createElement("polyline", {
  points: "7 23 3 19 7 15"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21 13v2a4 4 0 0 1-4 4H3"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-repeat"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/icon_repeat.6ec5bad1.svg";
export { SvgComponent as ReactComponent };